// extracted by mini-css-extract-plugin
export default {"card":"TestimonialCard_card__fwktF","avatar":"TestimonialCard_avatar__54NI6","quotes":"TestimonialCard_quotes__IP6pj","text":"TestimonialCard_text__-8hG2"};